/**
 * The default card back: noun-shaped, used by any app that doesn't ship its own.
 *
 * Adds the article, the plural and the gender tint to the shared translation
 * back. 39 A1 nouns are uncountable and carry no plural, so the arrow is
 * omitted rather than left dangling.
 */
import { TranslationCardBack } from '@/components/practice/TypeTranslationCard';
import type { NounsPayload } from '@/core/types';
import { articleBorder } from '@/lib/gender';
import { cn } from '@/lib/utils';

import type { CardBackProps } from '@/apps/types';

export function SharedCardBack(props: CardBackProps<NounsPayload>) {
  const { card } = props;
  const { article, plural } = card.payload;
  return (
    <TranslationCardBack
      {...props}
      frameClassName={cn('border-l-8', articleBorder(article))}
      headword={
        <>
          {article} {card.de}
          {plural ? ` → ${plural}` : null}
        </>
      }
    />
  );
}
